<template>
  <v-card outlined :min-width-400="$vuetify.breakpoint.smAndUp" :min-width-300="$vuetify.breakpoint.xsOnly">
    <v-snackbar v-model="snackbar.show" top :color="snackbar.color">
      {{ snackbar.text }}
    </v-snackbar>

    <v-card-title>
      <div class="subtitle-1">{{ companyName }}</div>
    </v-card-title>
    <v-card-subtitle>
      <div class="ml-4 headline">Sign in</div>
    </v-card-subtitle>
    <v-card-text>
      <v-form v-model="valid" ref="form">
        <v-text-field
          label="Email"
          name="email"
          type="text"
          :rules="[rules.required, rules.email]"
          v-model="credential.email"
          prepend-inner-icon="email"
          outlined
          autofocus
        ></v-text-field>
        <v-text-field
          label="Password"
          name="password"
          type="password"
          :rules="[rules.required]"
          v-model="credential.password"
          prepend-inner-icon="lock"
          @keyup.native.enter="signin"
          outlined
        ></v-text-field>
        <v-container>
          <v-row no-gutters>
            <v-col cols="6">
              <v-btn text small block @click="gotoAuth('verify')">Forgot password?</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn class="sign-in" :disabled="!valid" large block color="success lighten-1" @click="signin">Sign In</v-btn>
            </v-col>
            <v-col cols="12">
              <v-btn large block text @click="gotoAuth('signup')">Create account</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import UserService from '@/services/UserService.js'

@Component
export default class Signin extends Vue {
  @Getter companyName
  @Prop(String) source
  valid = false
  credential = { email: '', password: '' }
  rules = {
    required: v => !!v || 'Required',
    email: v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
  }
  snackbar = {
    show: false,
    color: null,
    text: null
  }

  @Action setUser

  signin () {
    this.$emit('loading', true)
    UserService.signin(this.credential)
      .then(resp => {
        this.setUser({
          user: resp.data
        })
        location.href = '/'
      })
      .catch(err => {
        console.error(err)
        this.snackbar.color = 'error'
        this.snackbar.text = 'Failed to sign in!'
        this.snackbar.show = true
        this.$emit('loading', false)
      })
  }

  gotoAuth (state) {
    this.$emit('set-auth-state', { state: state })
  }
}
</script>
